import cn from "classnames";
import { Col, Container, Row } from "react-bootstrap";

export default function ({
  className = "bg-blue text-white pt-5 pb-4",
  title,
  items,
  EditableText,
  theme = "dark",
}) {
  return (
    <div className={cn(className)}>
      <Container>
        <EditableText path="title" tag="h2" className="mb-4">
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </EditableText>
        <Row>
          {items.map((i) => (
            <Col xs={12} md={4}>
              <div className="bg-white text-dark p-4 text-center fw-bold mb-4">{i}</div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
